import type { NDateLocale } from './enUS'
import { uz } from 'date-fns/locale'

const dateUzUZ: NDateLocale = {
  name: 'uz-UZ',
  locale: uz
}

export default dateUzUZ
